<template>
    <div class="text-secondary-700 text-xs pt-1">
        <slot></slot>
    </div>
</template>